import { Center } from "@chakra-ui/react";
import onboardingWinners from "assets/images/svgs/onboarding-winners.svg";
import history from "infra/helpers/history";
import { useCurrentAuth } from "core/features/auth/auth.store";
import CardOnboarding from "../components/card-onboarding";

function PrimeiroPasso() {
  const { auth } = useCurrentAuth();

  return (
    <Center w="100vw" h="100vh">
      <CardOnboarding
        imageSrc={onboardingWinners}
        headingText={`Bem-vindo${auth.nome ? " " + auth.nome : ""}!`}
        subheadText="Tenha controle total da administração do seu condomínio. Autorização de visitantes, Reserva de espaços, Financeiro, Assembleias, e muito mais…"
        onNext={() => history.push("segundo-passo")}
        onNextText="VAMOS LÁ!"
        onPular={true}
        step={1}
      />
    </Center>
  );
}

export default PrimeiroPasso;
